import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, setupInstallPromptCapture } from "@/lib/pwa";

// Register the service worker + capture install prompts so we can offer
// "Install app" on the Profile page (mandatory for PWA installability).
registerServiceWorker();
setupInstallPromptCapture();

// Portrait lock — the app UI (dashboards, ledgers, print-ready forms)
// is designed for portrait phones/tablets; landscape mode wastes space
// and breaks the print preview A4 aspect. When running as an installed
// PWA we can call `screen.orientation.lock('portrait')`; in a normal
// browser tab this throws NotSupportedError which we silently ignore
// (a CSS overlay in index.css nudges the user to rotate back).
try {
  if (window.screen?.orientation?.lock) {
    window.screen.orientation.lock("portrait").catch(() => {});
  }
} catch { /* browsers that expose the property but throw on call */ }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
